import React from "react";
import { Link } from "react-router-dom";

import { SectionWrapperStyle } from "./SectionWrapper.style";

type SectionWrapperProps = {
  heading: string;
  subheading: string;
  children: React.ReactElement;
  id: any;
};

const SectionWrapper = (props: SectionWrapperProps) => {
  const { heading, subheading, children, id } = props;

  return (
    <SectionWrapperStyle>
      <Link to={`/playlist/${id}`}>
        <h2 className="heading">{heading}</h2>
        <h4 className="subheading">
          {subheading}{" "}
          <a rel="noreferrer" href="https://open.spotify.com/" target="_blank">
            <img
              className="image imageheading1"
              src="./static/spotify-logo.png"
              alt="playlist thumbnail"
            />
          </a>
        </h4>
      </Link>
      {children}
    </SectionWrapperStyle>
  );
};

export default SectionWrapper;
